import { action } from 'typesafe-actions';
import ActionTypes from 'store/practicas/actionTypes';
import { RequestStatus, Sort } from 'types';
import {
  CursoPractica,
  FormadorCurso,
  AlumnoPractica,
  EstadoCurso,
  FechaMinimaPractica,
  PracticaSeleccionada,
  InstructorPractica,
  PracticasCount,
  Practica,
  PracticaFilter,
  EstadoPractica,
  TipoServicio,
  Sociedad,
  JornadaUsuario,
  Estacion,
  TipoPractica,
  Provincias,
  CursoAuditoria,
  AlumnoAuditoria,
  PracticaAuditoria,
  RequestErrorMessagePayload,
  FechaMaximaPractica,
  FiltroPractica,
  InstructorData,
} from 'store/practicas/types';
import { SortBy, SortingSort } from 'consts';
import { InfoUser } from 'store/usuarios/types';

// Reset reducer
export const resetState = () => action(ActionTypes.RESET_STATE);

// Set reducer
export const setCursosPractica = (payload: CursoPractica[]) =>
  action(ActionTypes.SET_CURSOS_PRACTICA, payload);

export const setformadoresCursos = (payload: FormadorCurso[]) =>
  action(ActionTypes.SET_FORMADOR_CURSO, payload);

export const setAlumnosPractica = (payload: AlumnoPractica[]) =>
  action(ActionTypes.SET_ALUMNOS_PRACTICA, payload);

export const setEstadosCursos = (payload: EstadoCurso[]) =>
  action(ActionTypes.SET_ESTADOS_CURSOS, payload);

export const setFechaMinimaPractica = (
  payload: FechaMinimaPractica | RequestErrorMessagePayload
) => action(ActionTypes.SET_FECHA_MINIMA_PRACTICA, payload);

export const setFechaMaximaPractica = (
  payload: FechaMaximaPractica | RequestErrorMessagePayload
) => action(ActionTypes.SET_FECHA_MAXIMA_PRACTICA, payload);

export const setSort = (payload: Sort) => action(ActionTypes.SET_SORT, payload);

export const setSorting = (payload: SortBy | '') =>
  action(ActionTypes.SET_SORTING, payload);

export const setSortingSort = (payload: SortingSort | '') =>
  action(ActionTypes.SET_SORTING_SORT, payload);

export const resetSort = () => action(ActionTypes.RESET_SORT);
export const submitFilters = () => action(ActionTypes.SUBMIT_FILTERS);

export const setPracticasSeleccionada = (payload: PracticaSeleccionada) =>
  action(ActionTypes.SET_PRACTICAS_SELECCIONADA, payload);

export const setCursosActivosJornada = (payload: CursoPractica[]) =>
  action(ActionTypes.SET_CURSOS_ACTIVOS_JORNADA, payload);

export const setInstructoresPracticas = (payload: InstructorPractica[]) =>
  action(ActionTypes.SET_INSTRUCTORES_PRACTICAS, payload);

export const setInstructores = (payload: InstructorData[]) =>
  action(ActionTypes.SET_INSTRUCTORES, payload);

export const setPracticasCount = (payload: PracticasCount) =>
  action(ActionTypes.SET_PRACTICAS_COUNT, payload);

export const setPracticasAuditoriaCount = (payload: PracticasCount) =>
  action(ActionTypes.SET_PRACTICAS_AUDITORIA_COUNT, payload);

export const setPracticas = (payload: Practica[]) =>
  action(ActionTypes.SET_PRACTICAS, payload);

export const setPracticasByJornada = (payload: Practica[]) =>
  action(ActionTypes.SET_PRACTICAS_BY_JORNADA, payload);

export const resetPracticasByJornada = () =>
  action(ActionTypes.RESET_PRACTICAS_BY_JORNADA);

export const setPracticasAuditoria = (payload: PracticaAuditoria[]) =>
  action(ActionTypes.SET_PRACTICAS_AUDITORIA, payload);

export const setTodasPracticasAuditoria = (payload: PracticaAuditoria[]) =>
  action(ActionTypes.SET_TODAS_PRACTICAS_AUDITORIA, payload);

export const setPracticasFilter = (payload: PracticaFilter) =>
  action(ActionTypes.SET_PRACTICAS_FILTER, payload);

export const setEstadosPracticas = (payload: EstadoPractica[]) =>
  action(ActionTypes.SET_ESTADOS_PRACTICA, payload);

export const setTiposServicio = (payload: TipoServicio[]) =>
  action(ActionTypes.SET_TIPOS_SERVICIO, payload);

export const setSociedades = (payload: Sociedad[]) =>
  action(ActionTypes.SET_SOCIEDADES, payload);

export const setJornadasUsuario = (payload: JornadaUsuario[]) =>
  action(ActionTypes.SET_JORNADAS_USUARIO, payload);

export const setEstaciones = (payload: Estacion[]) =>
  action(ActionTypes.SET_ESTACIONES, payload);

export const setTiposPractica = (payload: TipoPractica[]) =>
  action(ActionTypes.SET_TIPOS_PRACTICA, payload);

export const setProvincias = (payload: Provincias[]) =>
  action(ActionTypes.SET_PROVINCIAS, payload);

export const setPages = (payload: number) =>
  action(ActionTypes.SET_PAGES, payload);

export const setSelectedPage = (payload: number) =>
  action(ActionTypes.SET_SELECTED_PAGE, payload);

export const setElementsPerPage = (payload: number) =>
  action(ActionTypes.SET_ELEMENTS_PER_PAGE, payload);

export const setCursosAuditoria = (payload: CursoAuditoria[]) =>
  action(ActionTypes.SET_CURSOS_AUDITORIA, payload);

export const setSelectedCursosAuditoria = (payload: number[]) =>
  action(ActionTypes.SET_SELECTED_CURSOS_AUDITORIA, payload);

export const setSelectedSociedadAuditoria = (payload: string[]) =>
  action(ActionTypes.SET_SELECTED_SOCIEDAD_AUDITORIA, payload);

export const setSelectedProvinciaAuditoria = (payload: string[]) =>
  action(ActionTypes.SET_SELECTED_PROVINCIA_AUDITORIA, payload);

export const removeSelectedProvinciasAuditoria = () =>
  action(ActionTypes.REMOVE_SELECTED_PROVINCIAS_AUDITORIA);

export const removeSelectedCursosAuditoria = () =>
  action(ActionTypes.REMOVE_SELECTED_CURSOS_AUDITORIA);

export const removeFilterAuditoria = () =>
  action(ActionTypes.REMOVE_FILTER_AUDITORIA);

export const setProvinciasAuditoria = (payload: string[]) =>
  action(ActionTypes.SET_PROVINCIAS_AUDITORIA, payload);

export const setAlumnosAuditoria = (payload: AlumnoAuditoria[]) =>
  action(ActionTypes.SET_ALUMNOS_AUDITORIA, payload);

export const setUserInfo = (payload: InfoUser[]) =>
  action(ActionTypes.SET_USER_INFO, payload);

export const exportExcel = () => action(ActionTypes.EXPORT_EXCEL);
// Requests
export const postAnularPracticaRequest = () =>
  action(ActionTypes.POST_ANULAR_PRACTICA_REQUEST);

export const postAuditoriaRequest = () =>
  action(ActionTypes.POST_AUDITORIA_REQUEST);

export const postAuditoriaEditRequest = () =>
  action(ActionTypes.POST_AUDITORIA_EDIT_REQUEST);

export const updatePracticas = () =>
  action(ActionTypes.SET_GET_PRACTICAS_UPDATE);

export const updatePracticasAuditoria = () =>
  action(ActionTypes.SET_GET_PRACTICAS_AUDITORIA_UPDATE);

export const postRechazarPracticaRequest = () =>
  action(ActionTypes.POST_RECHAZAR_PRACTICA_REQUEST);

export const postRechazarPracticaEditRequest = () =>
  action(ActionTypes.POST_RECHAZAR_PRACTICA_EDIT_REQUEST);

export const postReclamarPracticaRequest = () =>
  action(ActionTypes.POST_RECLAMAR_PRACTICA_REQUEST);

export const postValidarPracticaRequest = () =>
  action(ActionTypes.POST_VALIDAR_PRACTICA_REQUEST);

export const getFilterCursoPracticaRequest = (payload) =>
  action(ActionTypes.GET_FILTER_CURSO_PRACTICA_REQUEST, payload);

export const getFormadorCursoRequest = (payload) =>
  action(ActionTypes.GET_FORMADOR_CURSO_REQUEST, payload);

export const getFilterAlumnoPracticaRequest = (payload) =>
  action(ActionTypes.GET_FILTER_ALUMNO_PRACTICA_REQUEST, payload);

export const getFilterCursosByInstructoresRequest = (payload) =>
  action(ActionTypes.GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST, payload);

export const getFilterCursosByAlumnosRequest = (payload) =>
  action(ActionTypes.GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST, payload);

export const  getFilterCursosByAlumnosAuditoriaRequest = (payload) =>
  action(ActionTypes.GET_FILTER_CURSOS_BY_ALUMNOS_AUDITORIA_REQUEST, payload);

export const getFilterInstructoresByAlumnosRequest = (payload) =>
  action(ActionTypes.GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST, payload);

export const getFilterAlumnosByInstructoresRequest = (payload) =>
  action(ActionTypes.GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST, payload);

export const getEstadosCursosRequest = () =>
  action(ActionTypes.GET_ESTADOS_CURSOS_REQUEST);

export const getFechaMinimaPracticaRequest = () =>
  action(ActionTypes.GET_FECHA_MINIMA_PRACTICA_REQUEST);

export const getFechaMaximaPracticaRequest = () =>
  action(ActionTypes.GET_FECHA_MAXIMA_PRACTICA_REQUEST);

export const getPracticaSeleccionadaRequest = () =>
  action(ActionTypes.GET_PRACTICAS_SELECCIONADA_REQUEST);

export const getCursosActivosJornadaRequest = () =>
  action(ActionTypes.GET_CURSOS_ACTIVOS_JORNADA_REQUEST);

export const getInstructoresPracticasRequest = () =>
  action(ActionTypes.GET_INSTRUCTORES_PRACTICAS_REQUEST);

export const crearPracticaRequest = () =>
  action(ActionTypes.CREAR_PRACTICA_REQUEST);

export const getPracticasCountRequest = () =>
  action(ActionTypes.GET_PRACTICAS_COUNT_REQUEST);

export const getPracticasByJornadaModalRequest = () =>
  action(ActionTypes.GET_PRACTICAS_BY_JORNADA_REQUEST);

export const getPracticasAuditoriaCountRequest = () =>
  action(ActionTypes.GET_PRACTICAS_AUDITORIA_COUNT_REQUEST);

export const getPracticasRequest = () =>
  action(ActionTypes.GET_PRACTICAS_REQUEST);

export const getPracticasAuditoriaRequest = () =>
  action(ActionTypes.GET_PRACTICAS_AUDITORIA_REQUEST);

export const getEstadosPracticaRequest = () =>
  action(ActionTypes.GET_ESTADOS_PRACTICA_REQUEST);

export const getTipoServicioRequest = () =>
  action(ActionTypes.GET_TIPO_SERVICIO_REQUEST);

export const getSociedadesRequest = () =>
  action(ActionTypes.GET_SOCIEDADES_REQUEST);

export const getJornadasUsuarioRequest = () =>
  action(ActionTypes.GET_JORNADAS_USUARIO_REQUEST);

export const getEstacionesRequest = () =>
  action(ActionTypes.GET_ESTACIONES_REQUEST);

export const getTiposPracticaRequest = () =>
  action(ActionTypes.GET_TIPOS_PRACTICA_REQUEST);

export const getCursoAuditoriaRequest = () =>
  action(ActionTypes.GET_CURSO_AUDITORIA_REQUEST);

export const getProvinciasRequest = () =>
  action(ActionTypes.GET_PROVINCIAS_REQUEST);

export const getAlumnosAuditoriaRequest = () =>
  action(ActionTypes.GET_ALUMNOS_AUDITORIA_REQUEST);

export const getTodasPracticasAuditoria = () =>
  action(ActionTypes.GET_TODAS_PRACTICAS_AUDITORIA_RREQUEST);

// Requests statuses
export const setPostAnularPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_ANULAR_PRACTICA_REQUEST_STATUS, payload);

export const setPostAuditoriaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_AUDITORIA_REQUEST_STATUS, payload);

export const setPostRechazarPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_RECHAZAR_PRACTICA_REQUEST_STATUS, payload);

export const setPostReclamarPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_RECLAMAR_PRACTICA_REQUEST_STATUS, payload);

export const setPostValidarPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_VALIDAR_PRACTICA_REQUEST_STATUS, payload);

export const setGetFilterCursoPracticaRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FILTER_CURSO_PRACTICA_REQUEST_STATUS, payload);

export const setGetFormadorCursoRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FORMADOR_CURSO_REQUEST_STATUS, payload);

export const setGetCursosAuditoriaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_CURSOS_AUDITORIA_REQUEST_STATUS, payload);

export const setGetAlumnosAuditoriaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_ALUMNOS_AUDITORIA_REQUEST_STATUS, payload);

export const setGetPracticasByJornadaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_PRACTICAS_BY_JORNADA_REQUEST_STATUS, payload);

export const setGetFilterAlumnoPracticaRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FILTER_ALUMNO_PRACTICA_REQUEST_STATUS, payload);

export const setGetFilterCursosByInstructoresRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FILTER_CURSOS_BY_INSTRUCTORES_REQUEST_STATUS, payload);

export const setGetFilterCursosByAlumnosRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FILTER_CURSOS_BY_ALUMNOS_REQUEST_STATUS, payload);

export const setGetFilterInstructoresByAlumnosRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FILTER_INSTRUCTORES_BY_ALUMNOS_REQUEST_STATUS, payload);

export const setGetFilterAlumnosByInstructoresRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FILTER_ALUMNOS_BY_INSTRUCTORES_REQUEST_STATUS, payload);

export const setGetEstadosCursosRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_ESTADOS_CURSOS_REQUEST_STATUS, payload);

export const setGetFechaMinimaPracticaRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FECHA_MINIMA_PRACTICA_REQUEST_STATUS, payload);

export const setGetFechaMaximaPracticaRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_FECHA_MAXIMA_PRACTICA_REQUEST_STATUS, payload);

export const setGetPracticaSeleccionadaRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_PRACTICAS_SELECCIONADA_REQUEST_STATUS, payload);

export const setGetCursosActivosJornadaRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_CURSOS_ACTIVOS_JORNADA_REQUEST_STATUS, payload);

export const setGetInstructoresPracticasRequestStatus = (
  payload: RequestStatus
) => action(ActionTypes.SET_GET_INSTRUCTORES_PRACTICAS_REQUEST_STATUS, payload);

export const setCrearPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_CREAR_PRACTICA_REQUEST_STATUS, payload);

export const setGetPracticasCountRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_PRACTICAS_COUNT_REQUEST_STATUS, payload);

export const setGetProvinciasRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_PROVINCIAS_REQUEST_STATUS, payload);

export const setGetPracticasRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_PRACTICAS_REQUEST_STATUS, payload);
export const setGetPracticasRequestStatusLoading = () =>
  action(ActionTypes.SET_GET_PRACTICAS_REQUEST_STATUS_LOADING);

export const setGetPracticasAuditoriaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_PRACTICAS_AUDITORIA_REQUEST_STATUS, payload);
export const setGetAuditPracticesRequestStatusLoading = () =>
  action(ActionTypes.SET_GET_AUDIT_PRACTICES_REQUEST_STATUS_LOADING);

export const setGetEstadosPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_ESTADOS_PRACTICA_REQUEST_STATUS, payload);

export const setGetTipoServicioRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_TIPO_SERVICIO_REQUEST_STATUS, payload);

export const setGetSociedadesRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_SOCIEDADES_REQUEST_STATUS, payload);

export const setGetJornadasUsuarioRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_JORNADAS_USUARIO_REQUEST_STATUS, payload);

export const setGetEstacionesRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_ESTACIONES_REQUEST_STATUS, payload);

export const setGetTiposPracticaRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_TIPOS_PRACTICA_REQUEST_STATUS, payload);

export const resetPracticaSeleccionada = () =>
  action(ActionTypes.RESET_PRACTICA_SELECCIONADA);

export const getPracticas = (payload) => {
  return action(ActionTypes.GET_PRACTICAS, payload);
};
export const setPracticas2 = (payload) =>
  action(ActionTypes.SET_PRACTICAS_2, payload);
export const getPracticasCount = (payload) =>
  action(ActionTypes.GET_PRACTICAS_COUNT, payload);
export const setPracticasCount2 = (payload) =>
  action(ActionTypes.SET_PRACTICAS_COUNT_2, payload);
export const getPracticasExcel = (payload) =>
  action(ActionTypes.GET_PRACTICAS_EXCEL, payload);
export const getPracticasHorasFormacionInstructorExcel = (payload) =>
  action(ActionTypes.GET_PRACTICAS_HORAS_FORMACION_INSTRUCTOR_EXCEL, payload);
export const removePracticasFilter = () =>
  action(ActionTypes.REMOVE_PRACTICAS_FILTER);

//Filtros
export const setFiltros = (payload: FiltroPractica[]) =>
  action(ActionTypes.SET_FILTROS, payload);